import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Search } from '../shared/models/search.model';
import { PractitionerService } from '../shared/services/practitioner.service';
import { Practitioner } from '../shared/models/practitioner.model';
import { SearchResult } from '../shared/models/search-result.model';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  searchParameters: Search = new Search(null, null, null, null, null, null);
  searchResults: SearchResult[] = [];
  currentWindowWidth: number;
  resultsLoaded: boolean;
  selectedPractitioner: string;

  constructor(private route: ActivatedRoute, private practitionerService: PractitionerService) { }

  ngOnInit(): void {
    this.currentWindowWidth = window.innerWidth;
    this.route.queryParams.subscribe((queryParams: Params) => {
        this.searchParameters = new Search(
          queryParams['query'],
          queryParams['location'],
          queryParams['language'],
          queryParams['insurance'],
          queryParams['lat'],
          queryParams['lng']
        );
        this._search(this.searchParameters);
    });
  }

  _search(searchParameters: Search) {
    this.practitionerService.searchPractitioners(searchParameters).then((results: SearchResult[]) => {
      this.searchResults = results;
      this.resultsLoaded = true;
    });
  }

  practitionerSelected(result: SearchResult): void {
    this.selectedPractitioner = result.practitioner.id;
    let el = document.getElementById(result.practitioner.id);
    el.scrollIntoView();
  }

  @HostListener('window:resize')
  onResize() {
    this.currentWindowWidth = window.innerWidth;
  }
}
